import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { resolvePatientDataCollectionConfig } from '@aldebaran/common/util/patientDataCollection';

import { RootState } from '@/types/graph';

export const usePatientDataCollectionConfig = () => {
  const rawConfig = useSelector(
    (state: RootState) =>
      state.consultation.practice?.patientDataCollectionConfig,
  );

  return useMemo(
    () => resolvePatientDataCollectionConfig(rawConfig),
    [rawConfig],
  );
};
